'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _formatMuiErrorMessage from "@mui/utils/formatMuiErrorMessage";
import * as React from 'react';
import { unstable_useForkRef as useForkRef } from '@mui/utils';
import { useFormControlContext } from "../FormControl/index.js";
import { extractEventHandlers } from "../utils/extractEventHandlers.js";
/**
 *
 * Demos:
 *
 * - [Input](https://mui.com/base-ui/react-input/#hook)
 *
 * API:
 *
 * - [useInput API](https://mui.com/base-ui/react-input/hooks-api/#use-input)
 */ export function useInput() {
    var parameters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var defaultValueProp = parameters.defaultValue, tmp = parameters.disabled, disabledProp = tmp === void 0 ? false : tmp, tmp1 = parameters.error, errorProp = tmp1 === void 0 ? false : tmp1, onBlur = parameters.onBlur, onChange = parameters.onChange, onFocus = parameters.onFocus, tmp2 = parameters.required, requiredProp = tmp2 === void 0 ? false : tmp2, valueProp = parameters.value, inputRefProp = parameters.inputRef;
    var formControlContext = useFormControlContext();
    var defaultValue;
    var disabled;
    var error;
    var required;
    var value;
    if (formControlContext) {
        defaultValue = undefined;
        var _formControlContext_disabled;
        disabled = (_formControlContext_disabled = formControlContext.disabled) !== null && _formControlContext_disabled !== void 0 ? _formControlContext_disabled : false;
        var _formControlContext_error;
        error = (_formControlContext_error = formControlContext.error) !== null && _formControlContext_error !== void 0 ? _formControlContext_error : false;
        var _formControlContext_required;
        required = (_formControlContext_required = formControlContext.required) !== null && _formControlContext_required !== void 0 ? _formControlContext_required : false;
        value = formControlContext.value;
        if (process.env.NODE_ENV !== 'production') {
            var definedLocalProps = [
                'defaultValue',
                'disabled',
                'error',
                'required',
                'value'
            ].filter(function(prop) {
                return parameters[prop] !== undefined;
            });
            if (definedLocalProps.length > 0) {
                console.warn([
                    'MUI: You have set props on an input that is inside a FormControl.',
                    'Set these props on a FormControl instead. Otherwise they will be ignored.',
                    "Ignored props: ".concat(definedLocalProps.join(', '))
                ].join('\n'));
            }
        }
    } else {
        defaultValue = defaultValueProp;
        disabled = disabledProp;
        error = errorProp;
        required = requiredProp;
        value = valueProp;
    }
    var _React_useRef = React.useRef(value != null), isControlled = _React_useRef.current;
    var handleInputRefWarning = React.useCallback(function(instance) {
        if (process.env.NODE_ENV !== 'production') {
            if (instance && instance.nodeName !== 'INPUT' && !instance.focus) {
                console.error([
                    'MUI: You have provided a `slots.input` to the input component',
                    'that does not correctly handle the `ref` prop.',
                    'Make sure the `ref` prop is called with a HTMLInputElement.'
                ].join('\n'));
            }
        }
    }, []);
    var inputRef = React.useRef(null);
    var handleInputRef = useForkRef(inputRef, inputRefProp, handleInputRefWarning);
    var _React_useState = _sliced_to_array(React.useState(false), 2), focused = _React_useState[0], setFocused = _React_useState[1];
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    React.useEffect(function() {
        if (!formControlContext && disabled && focused) {
            setFocused(false);
            // @ts-ignore
            onBlur === null || onBlur === void 0 ? void 0 : onBlur();
        }
    }, [
        formControlContext,
        disabled,
        focused,
        onBlur
    ]);
    var handleFocus = function(otherHandlers) {
        return function(event) {
            var _otherHandlers_onFocus;
            // Fix a bug with IE11 where the focus/blur events are triggered
            // while the component is disabled.
            if (formControlContext === null || formControlContext === void 0 ? void 0 : formControlContext.disabled) {
                event.stopPropagation();
                return;
            }
            (_otherHandlers_onFocus = otherHandlers.onFocus) === null || _otherHandlers_onFocus === void 0 ? void 0 : _otherHandlers_onFocus.call(otherHandlers, event);
            if (formControlContext && formControlContext.onFocus) {
                var _formControlContext_onFocus;
                formControlContext === null || formControlContext === void 0 ? void 0 : (_formControlContext_onFocus = formControlContext.onFocus) === null || _formControlContext_onFocus === void 0 ? void 0 : _formControlContext_onFocus.call(formControlContext);
            } else {
                setFocused(true);
            }
        };
    };
    var handleBlur = function(otherHandlers) {
        return function(event) {
            var _otherHandlers_onBlur;
            (_otherHandlers_onBlur = otherHandlers.onBlur) === null || _otherHandlers_onBlur === void 0 ? void 0 : _otherHandlers_onBlur.call(otherHandlers, event);
            if (formControlContext && formControlContext.onBlur) {
                formControlContext.onBlur();
            } else {
                setFocused(false);
            }
        };
    };
    var handleChange = function(otherHandlers) {
        return function(event) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            var // @ts-ignore
            _otherHandlers_onChange;
            var _formControlContext_onChange, _otherHandlers_onChange1;
            if (!isControlled) {
                var element = event.target || inputRef.current;
                if (element == null) {
                    throw new Error(process.env.NODE_ENV !== "production" ? 'MUI: Expected valid input target. ' + 'Did you use a custom `slots.input` and forget to forward refs? ' + 'See https://mui.com/r/input-component-ref-interface for more info.' : _formatMuiErrorMessage(17));
                }
            }
            formControlContext === null || formControlContext === void 0 ? void 0 : (_formControlContext_onChange = formControlContext.onChange) === null || _formControlContext_onChange === void 0 ? void 0 : _formControlContext_onChange.call(formControlContext, event);
            (_otherHandlers_onChange1 = otherHandlers.onChange) === null || _otherHandlers_onChange1 === void 0 ? void 0 : (_otherHandlers_onChange = _otherHandlers_onChange1).call.apply(_otherHandlers_onChange, [
                otherHandlers,
                event
            ].concat(_to_consumable_array(args)));
        };
    };
    var handleClick = function(otherHandlers) {
        return function(event) {
            var _otherHandlers_onClick;
            if (inputRef.current && event.currentTarget === event.target) {
                inputRef.current.focus();
            }
            (_otherHandlers_onClick = otherHandlers.onClick) === null || _otherHandlers_onClick === void 0 ? void 0 : _otherHandlers_onClick.call(otherHandlers, event);
        };
    };
    var getRootProps = function() {
        var externalProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // onBlur, onChange and onFocus are forwarded to the input slot.
        var propsEventHandlers = extractEventHandlers(parameters, [
            'onBlur',
            'onChange',
            'onFocus'
        ]);
        var externalEventHandlers = _object_spread({}, propsEventHandlers, extractEventHandlers(externalProps));
        return _object_spread_props(_object_spread({}, externalProps, externalEventHandlers), {
            onClick: handleClick(externalEventHandlers)
        });
    };
    var getInputProps = function() {
        var externalProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var propsEventHandlers = {
            onBlur: onBlur,
            onChange: onChange,
            onFocus: onFocus
        };
        var externalEventHandlers = _object_spread({}, propsEventHandlers, extractEventHandlers(externalProps));
        var mergedEventHandlers = _object_spread_props(_object_spread({}, externalEventHandlers), {
            onBlur: handleBlur(externalEventHandlers),
            onChange: handleChange(externalEventHandlers),
            onFocus: handleFocus(externalEventHandlers)
        });
        return _object_spread(_object_spread_props(_object_spread(_object_spread_props(_object_spread({}, mergedEventHandlers), {
            'aria-invalid': error || undefined,
            defaultValue: defaultValue,
            value: value,
            required: required,
            disabled: disabled
        }), externalProps), {
            ref: handleInputRef
        }), mergedEventHandlers);
    };
    return {
        disabled: disabled,
        error: error,
        focused: focused,
        formControlContext: formControlContext,
        getInputProps: getInputProps,
        getRootProps: getRootProps,
        inputRef: handleInputRef,
        required: required,
        value: value
    };
}
